import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { OneToolStore } from '../../stores/oneToolStore';

export const useOneToolStore = () =>
  useContext<{
    oneToolStore: OneToolStore;
  }>(StoreContext);
